import { clamp } from 'lodash'
import { ReactNode } from 'react'
import CheckMarkGreen from '../../../../images/CheckMarkGreen.svg'

interface ProgressCardProps extends React.HTMLAttributes<HTMLDivElement> {
  numberCompleted: number
  numberTotal?: number
  children: ReactNode
  active: boolean
  label?: string
}

export function ProgressCard({
  active,
  numberCompleted,
  numberTotal,
  children,
  label,
  ...props
}: ProgressCardProps) {
  const progress = numberTotal
    ? clamp((numberCompleted / Math.max(numberTotal, 1)) * 100, 0, 100)
    : 0
  const invalid = numberTotal == null || progress < 100

  return (
    <div
      {...props}
      className={`
                ${active ? 'tw-border-primary' : 'tw-border-system-grey-300'}
                ${
                  props.onClick
                    ? 'tw-cursor-pointer hover:tw-bg-system-grey-50'
                    : ''
                }
                  tw-flex 
                  tw-items-center 
                  tw-justify-between 
                  tw-border 
                  tw-rounded 
                  tw-border-solid 
                  tw-w-full 
                  tw-py-3 
                  tw-px-4 
                  tw-shadow 
                  last:tw-mb-0`}>
      <div className="tw-flex tw-w-full">
        <ProgressCircle
          className={
            invalid
              ? 'tw-border-transparent'
              : 'tw-border-success tw-border-opacity-40 tw-bg-success tw-bg-opacity-10'
          }
          progress={progress}>
          {invalid ? (
            <span className="tw-text-sm tw-font-medium">
              {label || `${numberCompleted}/${numberTotal}`}
            </span>
          ) : (
            <CheckMarkGreen />
          )}
        </ProgressCircle>
        <div className="tw-flex tw-w-full tw-overflow-x-hidden tw-items-center">
          {children}
        </div>
      </div>
    </div>
  )
}

type ProgressCircleProps = {
  children?: ReactNode
  className: string
  sizeClassName?: string
  progress: number
}

export function ProgressCircle({
  children,
  className,
  sizeClassName = 'tw-w-12 tw-h-12',
  progress,
}: ProgressCircleProps) {
  return (
    <div
      className={`
      ${className}
      tw-flex-shrink-0
      tw-rounded-full
      tw-border-2
      tw-border-solid 
      tw-flex
      tw-items-center
      tw-justify-center
      ${sizeClassName}`}
      style={{
        background:
          progress < 100
            ? `linear-gradient(white, white) padding-box, conic-gradient(#46C13C ${progress}%, lightgrey ${progress}%) border-box`
            : undefined,
      }}>
      {children}
    </div>
  )
}
